import axiosInstance from "./AxiosInstance";

const JobService = {
  getJobs: async (page = 1, limit = 10, search = "", jobStatus = "", categories = "", employees = "", customers = "", tasks = "", startDate = "", endDate = "", approvalStatus = "all", drafts = false, archived = false) => {
    try {
      let params = {};
      if (page && limit) {
        params = {
          ...params,
          page,
          limit,
        };
      }
      if (search) {
        params = {
          ...params,
          search,
        };
      }
      if (jobStatus) {
        params = {
          ...params,
          jobStatus,
        };
      }
      if (categories) {
        params = {
          ...params,
          categories,
        };
      }
      if (employees) {
        params = {
          ...params,
          employees,
        };
      }
      if (customers) {
        params = {
          ...params,
          customers,
        };
      }
      if (tasks) {
        params = {
          ...params,
          tasks,
        };
      }
      if (startDate) {
        params = {
          ...params,
          startDate,
        };
      }
      if (endDate) {
        params = {
          ...params,
          endDate,
        };
      }
      params = {
        ...params,
        approvalStatus,
      };
      if (drafts) {
        params = {
          ...params,
          drafts,
        };
      }
      if (archived) {
        params = {
          ...params,
          archived: true,
        };
      }
      const response = await axiosInstance.get("/v1/jobs", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getJobById(id) {
    return axiosInstance.get(`/v1/job/${id}`);
  },

  createJob: async (jobData) => {
    try {
      const response = await axiosInstance.post("/v1/job", jobData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  createDraft: async (jobData) => {
    try {
      const response = await axiosInstance.post("/v1/job/draft", jobData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateJob: async (id, jobData) => {
    try {
      const response = await axiosInstance.put(`/v1/job/${id}`, jobData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  approveJob: async (id) => {
    try {
      const response = await axiosInstance.patch(`/v1/job/${id}/approve`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteJob: async (jobId) => {
    try {
      const response = await axiosInstance.delete(`/v1/job/${jobId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  archiveJob: async (jobId, isArchived = true) => {
    try {
      const response = await axiosInstance.patch(`/v1/job/${jobId}/archive`, {
        isArchived
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  workJob: async (jobId, payload) => {
    try {
      const response = await axiosInstance.patch(`/v1/job/${jobId}/work`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  renewRecurringJob: async (reoccurringId, payload) => {
    try {
      const response = await axiosInstance.post(`/v1/job/recurring/${reoccurringId}/renew`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCustomerTasksHistory: async (customerId, categoryId, limit = 20) => {
    try {
      const response = await axiosInstance.get('/v1/jobs/customer-tasks/history', {
        params: { customerId, categoryId, limit }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default JobService;
